import React, {useCallback, useState} from 'react';
import {Button, Col, Row} from 'reactstrap';

import Modal from 'components/Modal';
import useExitIntent from 'utils/useExitIntent.js';

export default function ModalExitScreening(props) {
  const {isOpen, toggle} = useExitIntent(30000);
  return (
    <Modal className="modal-exit-intent modal-exit-intent-screening" isOpen={isOpen} toggle={toggle}>
      <Row className="text-center text-lg-left d-flex align-items-stretch m-0">
        <Col xs="12" lg="7" className="modal-exit-intent-copy order-lg-2 my-auto">
          <h4 className="section-heading mb-4">Did you know?</h4>
          <p>
            Right now, you can own <br className="d-none d-lg-block d-xl-none" />
            this special event <br className="d-none d-sm-block d-lg-none" />
            edition of <br className="d-none d-lg-block d-xl-none" />
            <i>Fantastic Fungi</i> for only $7.
          </p>
          <p>
            Watch it again and again! <br className="d-none d-sm-block" />
            Have a movie night with friends!
          </p>
          <p>
            For less than the cost of a matinee movie ticket, you’ll <br className="d-none d-sm-block d-md-none" />
            be helping us bring this must-see film to more people whose lives will be changed{' '}
            <br className="d-none d-md-block d-lg-none d-xl-block" />
            by the wisdom of fungi.
          </p>
          <p>
            Thank you for supporting the arts <br className="d-none d-sm-block" />
            and this important mission!
          </p>
          <Row className="d-flex align-items-center mt-5">
            <Col xs="12" lg="6" className="mb-4 mb-lg-0">
              <Button
                className="text-uppercase text-white btn-exit-orange btn-exit-orange-screening"
                color="cta-ff"
                onClick={toggle}
                block
              >
                Yes, I love a <br className="d-none d-lg-block" />
                great deal
              </Button>
            </Col>
            <Col xs="12" lg="6">
              <Button
                className="text-uppercase text-white btn-exit-gray-ff-screening"
                color="exit-gray-ff"
                onClick={toggle}
                block
              >
                No thanks, <br className="d-none d-lg-block" />I won’t want to <br className="d-none d-lg-block" />
                watch this film again
              </Button>
            </Col>
          </Row>
        </Col>
        <Col xs="12" lg="5" className="exit-modal-image-col order-lg-1">
          <div
            className="exit-modal-image"
            style={{backgroundImage: `url('${require('static/backgrounds/1203779462-exit.jpg')}')`}}
          />
        </Col>
      </Row>
    </Modal>
  );
}
